module.exports = __webpack_public_path__ + "img/tu07.9f2d3e9b.png";